import script from "./update-password.vue?vue&type=script&setup=true&lang=js"
export * from "./update-password.vue?vue&type=script&setup=true&lang=js"

import "./update-password.vue?vue&type=style&index=0&id=329c77d6&lang=scss&scoped=true"

import exportComponent from "/Users/tyk/Desktop/work/kangleiot/biz-sharingspace/sharing-space-admin-ui/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-329c77d6"]])

export default __exports__